export default __webpack_public_path__ + "static/media/ola.17eb2ad5.png";